import { render, staticRenderFns } from "./Ma.vue?vue&type=template&id=e50221a0&"
import script from "./Ma.vue?vue&type=script&lang=js&"
export * from "./Ma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports